import AbstractTool from "./AbstractTool";
import Modal from "../gui/Modal";

export default class HelpTool extends AbstractTool {
    constructor(provider, mode) {
        super(provider);

        this.mode = mode;
        let hotKeysTable = this.p.createElement('table').class('table-data');
        let tBody = this.p.createElement('tbody').parent(hotKeysTable);

        let hotkeys = [
            {
                'section': 'General hotkeys',
                'keys': [
                    { 'key': 'SPACE', 'action': 'Hold to enable mouse drag navigation' },
                    { 'key': 'C', 'action': 'Select tool' },
                    { 'key': 'A', 'action': 'Shapes tool', 'mode': 'edit' },
                    { 'key': 'N', 'action': 'Navigation' },
                    { 'key': 'SHIFT + E', 'action': 'Erase tool', 'mode': 'edit' },
                    { 'key': 'SHIFT + I', 'action': 'Image tool', 'mode': 'edit' },
                    { 'key': ', (comma)', 'action': 'Settings' },
                    { 'key': 'H', 'action': 'Help (this menu)' },
                    { 'key': 'SHIFT + R', 'action': 'Reset view' },
                    { 'key': 'CTRL + S', 'action': 'Save plan', 'mode': 'edit' },
                    { 'key': 'SHIFT + S', 'action': 'Toggle snap to grid', 'mode': 'edit' },
                    { 'key': 'SHIFT + G', 'action': 'Toggle show grid' },
                    { 'key': 'SHIFT + L', 'action': 'Toggle show labels' },
                    { 'key': 'ALT + L', 'action': 'Toggle lock labels', 'mode': 'edit' },
                    { 'key': 'ALT + I', 'action': 'Toggle show image' },
                    { 'key': 'S', 'action': 'Search tab', 'mode': 'edit' },
                    { 'key': 'L', 'action': 'Lists tab', 'mode': 'edit' },
                    { 'key': 'I', 'action': 'Info tab' },
                    { 'key': 'E', 'action': 'Elements tab' },
                    { 'key': 'P', 'action': 'Plants tab' },
                    { 'key': '+', 'action': 'Zoom in' },
                    { 'key': '-', 'action': 'Zoom out' },
                    { 'key': 'Scroll', 'action': 'Zoom in/out' },
                    { 'key': 'CTRL + Scroll', 'action': 'Vertical navigation' },
                    { 'key': 'SHFT + Scroll', 'action': 'Horizontal navigation' },
                    { 'key': 'ARROWS', 'action': 'Move view/navigate' },
                ],
            },
            {
                'mode': 'edit',
                'section': 'While selecting',
                'keys': [
                    { 'key': 'CTRL + drag', 'action': 'Add to selection' },
                    { 'key': 'SHIFT + drag', 'action': 'Subtract from selection' },
                    { 'key': 'CTRL + A', 'action': 'Select all' },
                    { 'key': 'ARROWS', 'action': 'Move selection' },
                    { 'key': 'D', 'action': 'Duplicate selection' },
                    { 'key': 'BCKSP & DEL', 'action': 'Delete selection' },
                    { 'key': 'ESC', 'action': 'Unselect' },
                    { 'key': 'SHIFT + O', 'action': 'Bring shape to the front' },
                    { 'key': 'SHIFT + A', 'action': 'Send shape to the back' },
                    { 'key': 'SHIFT + F', 'action': 'Bring shape forwards' },
                    { 'key': 'SHIFT + B', 'action': 'Send shape backwards' },
                ]
            },
            {
                'mode': 'edit',
                'section': 'While drawing an element or having it selected',
                'keys': [
                    { 'key': 'B', 'action': 'Focus label input (only select)' },
                    { 'key': 'Z', 'action': 'Focus size input (ellipse)' },
                    { 'key': 'W', 'action': 'Focus width input (rectangle)' },
                    { 'key': 'G', 'action': 'Focus height input (rectangle)' },
                    { 'key': '1-9', 'action': 'Focus segment # input (free shape and line)' },
                    { 'key': 'SHIFT + X', 'action': 'Toggle fill' },
                    { 'key': 'X', 'action': 'Focus fill color' },
                    { 'key': 'SHIFT + K', 'action': 'Toggle stroke' },
                    { 'key': 'K', 'action': 'Focus stroke color' },
                ]
            },
            {
                'mode': 'edit',
                'section': 'While selecting or adding species to element',
                'keys': [
                    { 'key': 'Right mouse button', 'action': 'Open menu with overlapping elements' },
                ]
            },
            {
                'mode': 'edit',
                'section': 'Drawing shapes',
                'keys': [
                    { 'key': 'R', 'action': 'Draw rectangles' },
                    { 'key': 'F', 'action': 'Draw free shape' },
                    { 'key': 'Y', 'action': 'Draw lines' },
                    { 'key': 'O', 'action': 'Draw ellipse' },
                    { 'key': 'ESC', 'action': 'Undo fixed length/Undo drawing' },
                    { 'key': 'Enter', 'action': 'Finish drawing' },
                    { 'key': 'Double click', 'action': 'Finish drawing polygon/line' },
                ]
            },
            {
                'mode': 'edit',
                'section': 'While placing a plant or adding a species',
                'keys': [
                    { 'key': 'hold SHIFT', 'action': 'The tool stays active and you can place/add multiple times' }
                ]
            },
            {
                'mode': 'edit',
                'section': 'While manipulating an image',
                'keys': [
                    { 'key': 'M', 'action': 'Move image and change size' },
                    { 'key': 'R', 'action': 'Rotate image' },
                    { 'key': 'Q', 'action': 'Scale image' },
                ]
            }
        ];

        this.createTable(tBody, hotkeys);

        this.helpMenu = new Modal(this.provider);
        this.helpMenu.onClickOutside(() => this.tools.setPreviousTool())
            .setTitle('Help')
            .addContent(hotKeysTable)
            .setButtonText('Done')
            .onClickButton(() => this.tools.setPreviousTool())
            .hide();
    }

    createTable(tBody, elements) {
        elements.map((element) => {
            if (element['mode'] && element['mode'] !== this.mode) {
                return;
            }
            let header = this.p.createElement('tr').parent(tBody);
            this.p.createElement('th', element['section'])
                .parent(header)
                .attribute('colspan', 2)
                .style('background-color', '#1B2223')
                .style('color', '#B8E9E4');

            element['keys'].map((key) => {
                if (key['mode'] && key['mode'] !== this.mode) {
                    return;
                }
                let row = this.p.createElement('tr').parent(tBody);
                this.p.createElement('th', key['key']).parent(row);
                this.p.createElement('td', key['action']).parent(row);
            });
        });
    }

    activate() {
        this.helpMenu.show();
        this.helpMenu.addClass('-is-active');
        this.enableHotKeys = false;
    }

    deactivate() {
        this.helpMenu.hide();
        this.helpMenu.removeClass('-is-active');
        this.enableHotKeys = true;
    }

    pressKeyHotKeysDisabled(code) {
        switch (code) {
            case 27: // Escape
                this.tools.setPreviousTool();
                break;
        }
    }
}
